module.exports = __webpack_public_path__ + "static/media/strongher7_preview.3014fc63.jpg";